import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
/**
 * One number that matters, displayed like it matters.
 *
 * Financial software's real typography is the figures. A stat gives them the
 * stage: a quiet eyebrow, a large tabular number that lines up against its
 * neighbours, and one line of context underneath. Never a chart where a
 * number will do.
 */
export function StatBlock({ label, value, hint, tone, className, }) {
    return (_jsxs("div", { className: cn('rounded-[var(--radius-surface)] border border-border bg-surface p-4 shadow-[var(--shadow-card)]', className), children: [_jsx("p", { className: "text-xs font-semibold uppercase tracking-wider text-content-subtle", children: label }), _jsx("p", { className: cn('tabular mt-1.5 text-2xl font-bold tracking-tight', tone === 'danger' ? 'text-danger' : tone === 'success' ? 'text-success' : 'text-content'), children: value }), hint === undefined ? null : _jsx("p", { className: "mt-1 text-xs text-content-muted", children: hint })] }));
}
//# sourceMappingURL=stat.js.map